import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import CompanyNamePICModel from '../models/CompanyNamePICModel';

interface CompanyNamePICInputState {
    companyNamePICInput: CompanyNamePICModel,
    selectedCompanyNamePICId: string,
    companyNamePICInputExpand: boolean,
    triggerFocusCompanyNameInput: number,
    triggerSave: number,
    triggerRefreshInput: number,
}

const initialState: CompanyNamePICInputState = {
    companyNamePICInput: {
        id: "",
        companyName: "",
        pic: "",
        emailTo: "",
        emailCc: "",
        contactDetails: "",
    } as unknown as CompanyNamePICModel,
    selectedCompanyNamePICId: "",
    companyNamePICInputExpand: true,
    triggerFocusCompanyNameInput: 0,
    triggerSave: 0,
    triggerRefreshInput: 0,
}

export const CompanyNamePICInputSlice = createSlice({
    name: "CompanyNamePICInput",
    initialState,
    reducers: {
        setCompanyNamePICInputId: (state, action: PayloadAction<string>) => {
            state.companyNamePICInput.id = action.payload;
        },
        setCompanyNamePICInput: (state, action: PayloadAction<CompanyNamePICModel>) => {
            state.companyNamePICInput = action.payload;
        },
        setCompanyName: (state, action: PayloadAction<string>) => {
            state.companyNamePICInput.companyName = action.payload;
        },
        setPIC: (state, action: PayloadAction<string>) => {
            state.companyNamePICInput.pic = action.payload;
        },
        setEmailTo: (state, action: PayloadAction<string>) => {
            state.companyNamePICInput.emailTo = action.payload;
        },
        setEmailCc: (state, action: PayloadAction<string>) => {
            state.companyNamePICInput.emailCc = action.payload;
        },
        setContactDetails: (state, action: PayloadAction<string>) => {
            state.companyNamePICInput.contactDetails = action.payload;
        },
        setSelectedCompanyNamePICId: (state, action: PayloadAction<string>) => {
            state.selectedCompanyNamePICId = action.payload;
        },
        setCompanyNamePICInputExpand: (state, action: PayloadAction<boolean>) => {
            state.companyNamePICInputExpand = action.payload;
        },
        setTriggerFocusCompanyNameInput: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyNameInput = action.payload;
        },
        resetCompanyNamePICInput: (state) => {
            state.companyNamePICInput = initialState.companyNamePICInput;
        },
        setTriggerSave: (state, action: PayloadAction<number>) => {
            state.triggerSave = action.payload;
        },
        setTriggerRefreshInput: (state, action: PayloadAction<number>) => {
            state.triggerRefreshInput = action.payload;
        },
    }
});

export const CompanyNamePICInputSelector = createSelector(
    (state: RootState) => state.companyNamePICInput,
    (data) => data
);

export const {
    setCompanyNamePICInputId,
    setCompanyNamePICInput,
    setCompanyName,
    setPIC,
    setEmailTo,
    setEmailCc,
    setContactDetails,
    setSelectedCompanyNamePICId,
    setCompanyNamePICInputExpand,
    setTriggerFocusCompanyNameInput,
    resetCompanyNamePICInput,
    setTriggerSave,
    setTriggerRefreshInput,
} = CompanyNamePICInputSlice.actions;

export default CompanyNamePICInputSlice.reducer;